// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__29cFx","buttons":"SendReceipts_buttons__1GfAp","email":"SendReceipts_email__39gVa","bookApptTitle":"SendReceipts_bookApptTitle__RXROP"};